import { WhitelabelConfig } from '@whitelabel/types';

const HotelstormWhitelabelConfig: WhitelabelConfig = {
    displayName: 'Hotelstorm',
    termsOfUseUrl: 'https://save.rockettravelhotels.com/terms',
    privacyPolicyUrl: 'https://save.rockettravelhotels.com/privacy',
};

export default HotelstormWhitelabelConfig;
